<script>
  import { External, M } from '../../external';
  import EditVideoSection from './EditVideoSection.svelte';
  import { millisecondsToTimestamp } from '../../Common/tools';

  export let video;
  let timestamps = video?.timestamps || [];

  const openSectionModal = async (selected = { time: 0, label: '' }) => {
    return new Promise((resolve) => {
      External.Tools.showWindow({
        width: 500,
        isModal: false,
        withDarkBackground: true,
        buttons: [
          External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, async (popup) => {
            const result = popup.component().getResult();
            resolve(result);
            popup.close();
          }),
          External.Button(M.CANCEL, External.Button.CLASS_MIDDLE_GREY, (popup) => {
            resolve();
            popup.close();
          })
        ],
        action: {
          onShow: (popup, context) => {
            popup.bindComponent(
              new EditVideoSection({
                target: popup.getContentArea(),
                props: {
                  video: video,
                  timestamp: selected
                }
              })
            );
          }
        }
      });
    });
  };

  const newSectionModal = async () => {
    const newSection = { time: 0, label: '' };
    const result = await openSectionModal(newSection);
    if (result) {
      timestamps = [...timestamps, result];
    }
  };

  const editSectionModal = async (index) => {
    const selected = timestamps[index];
    if (!selected) {
      return;
    }

    const changed = await openSectionModal(selected);
    if (changed) {
      timestamps[index] = changed;
      timestamps = [...timestamps];
    }
  };

  const deleteSection = (index) => {
    timestamps.splice(index, 1);
    timestamps = [...timestamps];
  };

  export const getTimestamps = () => {
    return timestamps;
  };
</script>

<div class="popup-widget-wrapper">
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.VIDEO_CHAPTERS}</h4>
  <div class="col20 f-left t-center">
    <a on:click={newSectionModal} class="middle-button blue with-icon f-none inline-block">{M.ADD_VIDEO_CHAPTER}</a>
  </div>
  <span class="light-gray-text t-center col20 f-left mt-15 mb-5">{M.ADD_VIDEO_CHAPTER_DESC}</span>

  <div class="col20 f-left ui-sorable form-admin-style-2 mb-0">
    {#each timestamps as timestamp, index}
      <div class="col20 f-left">
        <div class="form-step-wrapper flex align-center space-between">
          <div class="flex align-center col20">
            <span
              on:click={() => {
                editSectionModal(index);
              }}
              class="video-time-badge flex-none rounded-effect">{millisecondsToTimestamp(timestamp.time)}</span>
            <input type="text" class="step-name flex-1" bind:value={timestamp.label} placeholder="{M.ENTER_CHAPTER_NAME}" />
          </div>
          <div class="buttons-wrapper flex-none ml-10">
            <a
              on:click={() => {
                deleteSection(index);
              }}
              data-tooltip="simpleDelete"
              class="delete delete-icon modify button-tooltip light-gray-icon circle-effect">
              <i class="material-icons-outlined">delete</i>
            </a>
          </div>
        </div>
      </div>
    {/each}
  </div>
</div>
